import React from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames';
import {reverse} from 'core/urls';
import {formatMoney} from 'core/utils';
import KeyValueList from 'components/key-value-list';
import styles from './styles.css';

const OrderCard = ({order}) => {
    return (
        <Link to={reverse('orderDetail', {id: order.id})} className={classNames(styles.root, styles.rollover)}>
            <div className={styles.header}>
                <i className={styles.boxIcon} />
                <p>
                    <span>Pedido #{order.id}</span>
                    {order.total > 0 && <span>{formatMoney(order, 'total')}</span>}
                </p>
            </div>
            <div className={styles.body}>
                <KeyValueList
                    data={order}
                    rows={[
                        {key: 'created', label: 'Fecha', format: value => moment(value).format('LLL')},
                        (order.createdBy) && {
                            key: 'createdBy',
                            label: 'Realizado por',
                            format: ({firstName, lastName, email}) => `${firstName} ${lastName} - ${email}`,
                        },
                        {key: 'category.name', label: 'Tipo'},
                        {
                            key: 'status.name',
                            label: 'Estado',
                        },
                    ]}
                />
                {order.shipments.map(shipment => (
                    <div key={shipment.id} className={styles.shipment}>
                        <span>
                            <span>Envío #{shipment.index}</span>{shipment.status.name}
                        </span>
                        <span>
                            <span>Tracking</span>{shipment.trackingId || 'NO DISPONIBLE'}
                        </span>
                    </div>
                ))}
            </div>
        </Link>
    );
};

export default OrderCard;



// WEBPACK FOOTER //
// ./components/order-grid/order-card/index.js